import React from 'react';
import { Route } from 'react-router-dom';

import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import AccountDetails from './Designer/AccountDetails'

import Dashboard from './Designer/Dashboard'


class PlatformHome extends React.Component {

  async componentWillMount() {
    await dispatch.integrations.getIntegrations()
    dispatch.platform.setAcceptServerEvents(true);
    dispatch.platform.getStats();
    dispatch.app.setCurrentContext("platform-dashboard");
    dispatch.platform.accountsCountsByPlans();
  }

  componentWillUnmount() {
    
    dispatch.platform.setAcceptServerEvents(false);
  }

  render() {

    return (
      <div>
        <Route exact path="/app/platform/home" render={() => (<Dashboard  {...this.props} />)} />
        <Route exact path="/app/platform/home/:accountId" render={(routeProps) => <AccountDetails {...this.props} {...routeProps} />}/>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.app.user,
    activeSessions: state.platform.activeSessions,
    accountsCount: state.platform.accountsCount,
    orgCount: state.platform.orgCount,
    userCount: state.platform.userCount,
    playbookCount: state.platform.playbookCount,
    contentCount: state.platform.contentCount,
    accounts: state.platform.accounts,
    loadingAccountsData: state.loading.effects.platform.getStats && state.loading.models.platform,
    unRegisteredUsersData: state.platform.unRegisteredUsersData,
    allAccounts: state.platform.allAccounts,
    accountDetail: state.app.accountDetail,
    loaderForAllAccount: state.loading.effects.platform.getAllAccounts && state.loading.models.platform,
    planCounts: state.platform.planCounts,
    integrationsList:state.integrations.integrationsList,
    consumptionDetails: state.account.consumptionDetails,
    loadingConsumptions: state.loading.effects.account.getConsumptionDetails,
    activitiesGenerated: state.account.activitiesGenerated,
    playbooksCreated: state.account.playbooksCreated,
    linksGenerated: state.account.linksGenerated,
  };
}

const connectedDashboard = connect(mapStateToProps)(PlatformHome);

export { connectedDashboard as PlatformHome };